module.exports = __webpack_public_path__ + "img/beef.daa3a325.png";